export enum DMEnum {
    SHAREPOINT = 'SPOL',
    EDOCS = 'EDOCS',
}
